<div class="avviso" matSnackBarLabel>
  <mat-icon class="avviso__icona" aria-hidden="true">{{ icona() }}</mat-icon>

  <div class="avviso__testo">
    @if (header()) {
      <span class="avviso__titolo">{{ header() }}</span>
    }
    <span class="avviso__corpo">{{ content() }}</span>
  </div>

  <span matSnackBarActions>
    <button
      type="button"
      class="avviso__chiudi"
      mat-icon-button
      matSnackBarAction
      aria-label="Chiudi l'avviso"
      (click)="notificationsService.hideNotification()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </span>
</div>
